import * as storage from '../../utils/storage';
import { redirectStringForStore } from '../../constants/storageKeys';
import { router } from 'expo-router';
import { useOnMount } from '../useOnMount';
import { useOnboardingRedirection } from '../navigation/useOnboardingRedirection';
import { useState } from 'react';

export const useManageRedirect = () => {
  const [redirectLink, setRedirectLink] = useState<string | null>(null);
  const [redirectTowardsReckoning, setRedirectTowardsReckoning] = useState(false);

  const {redirect: redirectToOnboarding} = useOnboardingRedirection();

  const manageRedirect = async () => {
    const redirect = await storage.loadString(redirectStringForStore);
    if (redirect) {
      setRedirectLink(redirect as string);
      setRedirectTowardsReckoning(redirect?.includes('fromReckoning=true'));
    }
  };

  const redirect = (letGoToOnboarding: boolean) => {
    // Consume the stored redirect HERE, the moment it is used.
    //
    // It used to be cleared only by AuthenticatedApp, which lives under the (private)
    // group -- while it is consumed here, under (public). So any stored value that did
    // not end up reaching the private app was never cleared and was replayed on every
    // single launch. A stale or no-longer-valid path therefore pinned the user on
    // "Oops, this page does not exist" forever: not-found is outside (private), so the
    // cleanup never ran, so the next launch repeated it. That also explains why a fresh
    // install never shows the bug -- there is nothing stored yet.
    //
    // A redirect is a one-shot "where the user was heading before logging in", so
    // dropping it as soon as we act on it is the correct lifetime regardless.
    storage.remove(redirectStringForStore);

    // Placeholders (a bare '/' or an internal '/_...' route) are never real
    // destinations; fall back rather than navigating into nothing.
    if (redirectLink && redirectLink.length > 1 && !redirectLink.startsWith('/_')) {
      try {
        router.navigate(redirectLink);
      } catch (e) {
        console.warn('useManageRedirect: stored redirect is not navigable', redirectLink, e);
        redirectToOnboarding(letGoToOnboarding);
      }
    } else {
      redirectToOnboarding(letGoToOnboarding);
    }
  };

  useOnMount(() => {
    manageRedirect();
  });

  return { redirectLink, redirectTowardsReckoning, redirect };
};